import React from 'react';

import { cssMap } from '@atlaskit/css';
import Skeleton from '@atlaskit/skeleton';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

const skeletonStyles = cssMap({
	embedReferenceContainer: {
		paddingBlock: token('space.100'),
		paddingInline: token('space.300'),
	},
	placeholderContainer: {
		width: '100%',
		height: '384px',
	},
	placeholderText: {
		width: '100%',
	},
	footerContainer: {
		paddingBottom: token('space.300'),
	},
});

export const DatabaseReferenceModalSkeleton = (): React.JSX.Element => {
	return (
		<Stack
			xcss={skeletonStyles.embedReferenceContainer}
			space="space.200"
			testId="reference-database-skeleton"
		>
			<Inline space="space.150" alignInline="start">
				<Skeleton isShimmering width={240} height={40} borderRadius={token('radius.small')} />
				<Skeleton isShimmering width={240} height={40} borderRadius={token('radius.small')} />
				<Skeleton isShimmering width={240} height={40} borderRadius={token('radius.small')} />
			</Inline>
			<Stack
				alignBlock="center"
				alignInline="center"
				space="space.400"
				xcss={skeletonStyles.placeholderContainer}
			>
				<Skeleton isShimmering width={108} height={108} borderRadius={token('radius.full')} />
				<Skeleton isShimmering width={316} height={14} borderRadius={token('radius.full')} />
			</Stack>
			<Inline alignInline="end" space="space.100" xcss={skeletonStyles.footerContainer}>
				<Skeleton isShimmering width={61} height={32} borderRadius={token('radius.small')} />
				<Skeleton isShimmering width={61} height={32} borderRadius={token('radius.small')} />
			</Inline>
		</Stack>
	);
};
